export default __webpack_public_path__ + "static/media/report-icon.ebc89b18.svg";